import {MODULE_BASE_CONFIG} from './core/utils/base.config';
// import JFPollyFills from './core/utils/pollyfills';
import {MODULE_DISTRIBUTION_DIRECTIVES} from './directives/app.directives.module';
import {MODULE_DISTRIBUTION_COMPONENTS} from './modules/distribution/index';
import {MODULE_LAYOUT} from './layouts/index';
import {MODULE_DISTRIBUTION_APP} from '../../constants/main.module.constants';
import {MODULE_DISTRIBUTION_SERVICES} from './services/app.services.module';
import {MODULE_DISTRIBUTION_DAO} from "./data/app_dao_module";
import {MODULE_DISTRIBUTION_FILTERS} from "./filters/app.filters.module";
import {MODULE_DISTRIBUTION_STATES} from "./states/app.states.module";

const appDependencies = [
    MODULE_BASE_CONFIG,
    MODULE_DISTRIBUTION_STATES,
    MODULE_LAYOUT,
    MODULE_DISTRIBUTION_COMPONENTS,
    MODULE_DISTRIBUTION_SERVICES,
    MODULE_DISTRIBUTION_DIRECTIVES,
    MODULE_DISTRIBUTION_DAO,
    MODULE_DISTRIBUTION_FILTERS,
    'ui.grid.draggable-rows',
    'angularMoment'
];

const vendorDependencies = [
    'ngMessages',
    'ngAnimate',
    'ui.utils',
    'ui.select',
    'ui.codemirror',
    'cfp.hotkeys',
    'ui.router',
    'ngCookies',
    'toaster',
    'ngSanitize',
    'ui.layout',
    'ui.select2',
    'ui.bootstrap',
    'ncy-angular-breadcrumb',
    'dibari.angular-ellipsis'
];

class distributionConfig {
    constructor($httpProvider) {
        this.$httpProvider = $httpProvider;
        this.initFixingOptions();
    }

    initFixingOptions() {
        // IE Promise refresh issue fix
        // initialize get if not there
        if (!this.$httpProvider.defaults.headers.get) {
            this.$httpProvider.defaults.headers.get = {};
        }

        // Answer edited to include suggestions from comments
        // because previous version of code introduced browser-related errors

        // disable IE ajax request caching
        this.$httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
        // extra
        this.$httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
        this.$httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
    }
}

distributionConfig.$inject = ['$httpProvider', 'JFrogUILibConfigProvider'];

angular.module(MODULE_DISTRIBUTION_APP, vendorDependencies.concat(appDependencies))
angular.register(MODULE_DISTRIBUTION_APP).config(distributionConfig);



// WEBPACK FOOTER //
// ./modules/distribution/distribution.module.js